import AuthForm from "@/components/AuthForm";
import AuthLayout from "@/layouts/AuthLayout";

const AdminSignIn = () => {
  return (
    <AuthLayout>
      <AuthForm />
    </AuthLayout>
  );
};

export default AdminSignIn;
